import { capitalize, lowerCase, upperCase } from 'lodash'
import { get } from 'utils/lodash'
import { UNIT_OF_MEASURE } from 'components/pricing/DisposalFeesV2/create-edit-disposal-fee-dialog/settings'

export const getFormattedUom = (unitOfMeasure = '', quantity = '', isCapitalize = false) => {
  const isExist = get(UNIT_OF_MEASURE, upperCase(unitOfMeasure))

  if (!isExist) {
    return unitOfMeasure
  }

  const formattedUom = isCapitalize ? capitalize(unitOfMeasure) : lowerCase(unitOfMeasure)
  return Number(quantity) === 1 ? formattedUom : `${formattedUom}s`
}
